import { TMemeData, TMemeDehydratedData, TSubmitMemeData } from './types';

export const dehydrateFormData = (data: TSubmitMemeData): any => {
	const { titleEn, titleHi, titleMr, subTitleEn, subTitleHi, subTitleMr, titleActive, subTitleActive, imageUrl } = data;
	const hydratedData: TMemeDehydratedData = {
		...data,
		imageUrl: typeof imageUrl === 'string' ? [imageUrl] : imageUrl,
		title: {
			en: titleEn,
			hi: titleHi,
			mr: titleMr
		},
		subTitle: {
			en: subTitleEn,
			hi: subTitleHi,
			mr: subTitleMr
		},
		visibility: {
			title: titleActive,
			subTitle: subTitleActive
		}
	};

	const dehydratedFields: (keyof TMemeDehydratedData)[] = [
		'titleEn',
		'titleHi',
		'titleMr',
		'subTitleEn',
		'subTitleHi',
		'subTitleMr',
		'titleActive',
		'subTitleActive',
		'likes',
		'shares',
		'id',
		'createdAt',
		'updatedAt',
		'metaInfo',
		'index'
	];

	dehydratedFields.forEach((key) => {
		delete hydratedData[key];
	});

	return hydratedData;
};

export const hydrateFormData = (data: TMemeData) => {
	const memePostData: TSubmitMemeData = {
		...data,
		titleEn: data.title.en,
		titleHi: data.title?.hi,
		titleMr: data.title?.mr,
		subTitleEn: data.subTitle?.en,
		subTitleHi: data.subTitle?.hi,
		subTitleMr: data.subTitle?.mr,
		titleActive: data.visibility?.title,
		subTitleActive: data.visibility?.subTitle,
		likes: data.metaInfo?.likes,
		shares: data.metaInfo?.shares,
		imageUrl: data.imageUrl[0]
	};
	return memePostData;
};

export const getClonedMemePostData = (data: TMemeData): TSubmitMemeData => {
	const clonedData: TSubmitMemeData = {
		titleEn: data.title.en,
		titleHi: data.title?.hi,
		titleMr: data.title?.mr,
		subTitleEn: data.subTitle?.en,
		subTitleHi: data.subTitle?.hi,
		subTitleMr: data.subTitle?.mr,
		titleActive: data.visibility?.title,
		subTitleActive: data.visibility?.subTitle,
		likes: 0,
		shares: 0,
		imageUrl: ''
	};
	return clonedData;
};
